var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00001 0.5C6.19032 0.5 6.36413 0.608036 6.44837 0.778688L7.87715 3.67323L11.0723 4.14026C11.2606 4.16778 11.4169 4.29978 11.4756 4.48078C11.5343 4.66179 11.4852 4.86041 11.3489 4.99318L9.03728 7.24468L9.58282 10.4255C9.61499 10.6131 9.53787 10.8027 9.38388 10.9145C9.22989 11.0264 9.02575 11.0411 8.85729 10.9525L6.00001 9.44992L3.14274 10.9525C2.97428 11.0411 2.77014 11.0264 2.61615 10.9145C2.46216 10.8027 2.38504 10.6131 2.41721 10.4255L2.96275 7.24468L0.651148 4.99318C0.514839 4.86041 0.465703 4.66179 0.524392 4.48078C0.58308 4.29978 0.73942 4.16778 0.9277 4.14026L4.12288 3.67323L5.55166 0.778688C5.6359 0.608036 5.80971 0.5 6.00001 0.5ZM6.00001 2.12963L4.90337 4.35131C4.8306 4.49874 4.69001 4.60097 4.52733 4.62474L2.07422 4.9833L3.84888 6.71182C3.96682 6.82669 4.02065 6.99226 3.99282 7.15452L3.5741 9.59584L5.76729 8.44246C5.91298 8.36585 6.08705 8.36585 6.23274 8.44246L8.42592 9.59584L8.00721 7.15452C7.97938 6.99226 8.03321 6.82669 8.15115 6.71182L9.92581 4.9833L7.4727 4.62474C7.31002 4.60097 7.16943 4.49874 7.09666 4.35131L6.00001 2.12963Z",
    fill: "#07364B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.23619cd4d1b7dbb2aa48bb6192b6f6fa.svg";
export { ForwardRef as ReactComponent };